<template>
  <CCardBody>
    <ul class="py-1">
      <li class="d-flex justify-content-between">
        <span class="text-gray-800 font-weight-bold">{{ $t(`manageBalance.planSummary.subTotal`) }}</span>
        <span class="text-gray-600">{{ formatNumber(subtotal) }} €</span>
      </li>
      <li class="d-flex justify-content-between">
        <span class="text-gray-800 font-weight-bold"
          >{{ $t(`manageBalance.planSummary.tax`) }}
          <CButton
            v-c-tooltip.hover="{
              content: `Placement`,
              placement: 'right-end',
            }"
            class="p-0 m-0"
          >
            <CIcon name="question" size="custom-size" :height="15" viewBox="0 0 32 32" class="mr-3" />
          </CButton>
        </span>
        <span class="text-gray-600">{{ tax ? tax : $t(`manageBalance.planSummary.taxMayApply`) }} €</span>
      </li>
    </ul>
  </CCardBody>
</template>

<script>
import { mapGetters } from 'vuex'
import { currencyFormat, currencyFormatStyleEnum } from '@/utils/numbersFormatUtil.js'

export default {
  name: 'CardSubTotal',
  props: {
    tax: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      placements: ['right-start', 'right', 'right-end', 'left-start', 'left', 'left-end'],
    }
  },

  computed: {
    isSummary() {
      return this.place == 'summary'
    },

    cartPackges() {
      return this.$store.state.balance.steps.cartPackges
    },

    subtotal() {
      if (!Array.isArray(this.cartPackges)) return '0.00'
      const total = this.cartPackges.reduce((sum, pack) => {
        const price = Number(pack?.package?.packSelected?.price) || 0
        const quantity = Number(pack?.quantity) || 0
        return sum + price * quantity
      }, 0)
      return total.toFixed(2)
    },
    period() {
      return this.$store.state.backOffice.steps.paymentPeriod
    },

    ...mapGetters({
      lang: 'getLang',
    }),
  },

  methods: {
    formatNumber(number) {
      return currencyFormat(number, currencyFormatStyleEnum.DECIMAL)
    },
    applyDiscount(value) {
      if (this.period == 3) {
        let discount = value * 0.1
        let newValue = value - discount
        return newValue.toFixed(1)
      }

      return value
    },
  },
}
</script>

<style lang="scss">
.tooltip-old-inner {
  background: #fff;
  color: #000;
  border: 1px solid #ccc;
}
.bs-tooltip-old-auto[x-placement^='right'] .arrow:before,
.bs-tooltip-old-right .arrow:before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #fff;
}
</style>
